<template>
  <footer>
      <div style="background:white;">
        <v-layout row wrap style="margin:10px">
          
          <v-flex xs1>
            <img width=120 :src="require('@/assets/en_co-fundedbytheeu_rgb_pos.png')">
          </v-flex>
          <v-flex xs6 style="font-size: 12px; line-height:14px">
            <small>
            © 2018-2024 Educational system and content development were supported by following projects: ERASMUS+ Programme 
                KA2 (FITPED: 2018-1-SK01-KA203-046382), (FITPED-AI: 2021-1-SK01-KA220-HED-000032095) and Ministry of Education SR (004UKF-2-1/2021); 
                CC-NC-SA 4.0 license granted.                
            </small>
          </v-flex>
          <v-flex xs5 style="font-size: 12px; line-height:14px">
            <small>
              Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union or Slovak Academic Association for International Cooperation. Neither the European Union nor the granting authority can be held responsible for them. 
            </small>
          </v-flex>
        </v-layout>
<!--        <div class="footer-app-info">
              <img class="footer-logo" :src="require('@/assets/eu_flag_co_funded_pos_rgb_right.jpg')">
            </div>
            <div  class="footer-app-info">
            <p>  </p>
            </div>
            <div  class="footer-app-info">
              <p> </p> 
             <div class="footer-app-links">
                <ul>
                    <li><a href="#">GDPR</a></li>
                </ul>
       </div> 
 -->      </div>
   </footer>
</template>

<script>
  export default {}
</script>

<style>
</style>